import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";
import { FormGroup, FormBuilder } from '@angular/forms';

import * as globalConst from './../../../constants';

@Injectable()
export class RelationEditService {

  constructor(private http: Http) { }

  private apiUrl = globalConst.baseAPI;  // URL para web api 



  getEconomicGroupClassifications(){
    return this.http
    .get(this.apiUrl + "/classificationgroup/v1/getclassificationgroup?$filter=Ativo&$orderby=Nome asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
    .map((res: Response) => res.json()).catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

  
  getRelations(id:any){
    return this.http
    .get(this.apiUrl + "/relationshiptypegroup/v1/getrelationshiptypegroup/"+id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
    .map((res: Response) => res.json()).catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

  updateRelations(form:any){
    var relation = {
      ID:form.ID,
      Nome:form.Nome,
      ClassificacaoGrupoEconomicoID: form.Classificacao,
      Ativo:form.Ativo
    }
    return this.http
    .put(this.apiUrl + "/relationshiptypegroup/v1/updaterelationshiptypegroup",relation , JSON.parse(localStorage.getItem('yara.connectionHeader')))
    .map((res: Response) => res.json()).catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/relations/service/relations-edit.service.ts